// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3J6cD","clinicsSelect":"TableHeading_clinicsSelect__3dyHr"};